//#region External module imports
import React from "react";
//#endregion

//#region Code body
function App() {
	return (<hgroup className="text box container" data-testid="app">
		<h2>Coming soon!</h2>
		<p>
			👋🏿 Hey! Thanks for your interest in my portfolio.
			<br />
			The site's mostly unavailable as I'm building everything at the moment, but I'm not leaving you empty-handed!
		</p>
		<p>Feel free to check out my socials using the menu above, and be sure to follow them for updates on the site, what I'm getting up to, or when I spin up a feed!</p>
	</hgroup>);
}
//#endregion

//#region Module exports
export default App;
//#endregion
